import { useCatalog } from '../lib/catalog';
import { Link, back } from '../lib/router';
import { useApp } from '../lib/store';
import { PosterLink } from '../components/Poster';
import { AppShell, PageHeader } from '../components/Shell';

export function Library() {
  const { shows: SHOWS, episodes: EPISODES } = useCatalog();
  const saves = useApp((s) => s.saves);
  const progress = useApp((s) => s.progress);
  const saved = SHOWS.filter((s) => saves[s.id]);
  const watchedShowIds = [...new Set(
    Object.entries(progress).sort((a, b) => b[1].updatedAt - a[1].updatedAt).map(([epId]) => EPISODES.find((e) => e.id === epId)?.showId)
  )].filter(Boolean) as string[];
  const history = watchedShowIds.map((id) => SHOWS.find((s) => s.id === id)!).filter(Boolean);

  return (
    <AppShell mobileHeader={false}>
      <div className="page">
        <PageHeader title="My library" onBack={() => back('/account')} />
        <section className="stack">
          <h2 className="rail-title">Saved shows</h2>
          {saved.length === 0 ? (
            <p className="empty">Tap Save on any show and it will appear here. <Link to="/explore" className="text-link">Find a show</Link></p>
          ) : (
            <div className="poster-grid">{saved.map((s) => <PosterLink key={s.id} show={s} size="fill" />)}</div>
          )}
        </section>
        <section className="stack">
          <h2 className="rail-title">Watch history</h2>
          {history.length === 0 ? <p className="empty">Shows you watch will appear here.</p> : (
            <div className="poster-grid">{history.map((s) => <PosterLink key={s.id} show={s} size="fill" />)}</div>
          )}
        </section>
        <section className="stack">
          <h2 className="rail-title">Downloads</h2>
          <p className="empty">Downloads are available in the Android and iPhone apps. They stay encrypted and work for 30 days offline.</p>
        </section>
      </div>
    </AppShell>
  );
}
